export interface SidSocketResponse {
  control_code?: string;
  device_link?: string;
  finished?: boolean;
  result?: SIDSessionResultCode;
  error?: string;
}

export enum SIDSessionResultCode {
  OK = 'OK', // session was completed successfully, there is a certificate, document number and possibly signature in return structure.
  USER_REFUSED = 'USER_REFUSED', // user refused the session.
  TIMEOUT = 'TIMEOUT', // there was a timeout, i.e. end user did not confirm or refuse the operation within given timeframe.
  DOCUMENT_UNUSABLE = 'DOCUMENT_UNUSABLE', // for some reason, this RP request cannot be completed. User must either check his/her Smart-ID mobile application or turn to customer support for getting the exact reason.
  WRONG_VC = 'WRONG_VC', // in case the multiple-choice verification code was requested, the user did not choose the correct verification code.
  REQUIRED_INTERACTION_NOT_SUPPORTED_BY_APP = 'REQUIRED_INTERACTION_NOT_SUPPORTED_BY_APP', // user app version does not support any of the allowedInteractionsOrder interactions.
  USER_REFUSED_CERT_CHOICE = 'USER_REFUSED_CERT_CHOICE', // user has multiple accounts and pressed Cancel on device choice screen on any device.
  USER_REFUSED_DISPLAYTEXTANDPIN = 'USER_REFUSED_DISPLAYTEXTANDPIN', // user pressed Cancel on PIN screen. Can be from the most common displayTextAndPIN flow or from verificationCodeChoice flow when user chosen the right code and then pressed cancel on PIN screen.
  USER_REFUSED_VC_CHOICE = 'USER_REFUSED_VC_CHOICE', // user cancelled verificationCodeChoice screen.
  USER_REFUSED_CONFIRMATIONMESSAGE = 'USER_REFUSED_CONFIRMATIONMESSAGE', // user cancelled on confirmationMessage screen.
  USER_REFUSED_CONFIRMATIONMESSAGE_WITH_VC_CHOICE = 'USER_REFUSED_CONFIRMATIONMESSAGE_WITH_VC_CHOICE', // user cancelled on confirmationMessageAndVerificationCodeChoice screen.
  USER_REFUSED_INTERACTION = 'USER_REFUSED_INTERACTION',

  NOT_FOUND = 'NOT_FOUND', // SID user not found
  INTERNAL_ERROR = 'INTERNAL_ERROR',
}
